/**
 * Payment button click retry — fix per il "doppio/multi tap" sui pulsanti
 * Acquista su Shop / Apple Pay / Shop Pay / Google Pay.
 *
 * Cause del bug originale:
 *  - Shopify renderizza il pulsante come "skeleton" disabilitato in attesa che
 *    il modulo portable-wallets si carichi e idrati il bottone.
 *  - Su mobile (rete lenta + CPU occupata da altri JS del theme) lo skeleton
 *    può durare 300-1500 ms.
 *  - I tap durante quella finestra finiscono nel vuoto.
 *
 * Strategia:
 *  - Cattura i tap sul wrapper del pulsante, in fase di capturing.
 *  - Se il bottone reale è già pronto, lascia che il browser gestisca il click.
 *  - Se siamo nello skeleton, programma un controllo periodico: appena il
 *    bottone è idratato, emette un click programmatico così l'utente non deve
 *    rifare il tap.
 *  - Per Apple Pay (su Safari iOS/macOS) il click programmatico potrebbe
 *    non triggerare la sessione Apple Pay (Apple richiede gesture sincrona).
 *    In quel caso il pulse CSS rimane visibile e l'utente, vedendo che il
 *    bottone è ora "pronto" (smette di pulsare), tappa di nuovo manualmente.
 *    Comunque tentiamo: in molti casi funziona anche su Apple devices, e se
 *    fallisce non rompe nulla.
 *
 * Caricato da theme.liquid con `defer`.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function findHydratedButton(container) {
    if (!container) return null;
    var btns = container.querySelectorAll('.shopify-payment-button__button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      // Bottone "vivo": niente disabled e niente aria-hidden
      if (!b.hasAttribute('disabled') && b.getAttribute('aria-hidden') !== 'true') {
        return b;
      }
    }
    return null;
  }

  var pendingTimer = null;
  var lastTapTimestamp = 0;

  function scheduleRetry(wrapper) {
    if (pendingTimer) {
      clearInterval(pendingTimer);
      pendingTimer = null;
    }

    var attempts = 0;
    var maxAttempts = 50; // 50 × 80 ms = 4 secondi totali
    pendingTimer = setInterval(function () {
      attempts++;
      var btn = findHydratedButton(wrapper);
      if (btn) {
        clearInterval(pendingTimer);
        pendingTimer = null;
        try {
          btn.click();
        } catch (err) {
          /* Apple Pay potrebbe rifiutare; nessun fallback necessario */
        }
      } else if (attempts >= maxAttempts) {
        clearInterval(pendingTimer);
        pendingTimer = null;
      }
    }, 80);
  }

  function handlePotentialSkeletonTap(e) {
    // Throttle: ignora tap doppi entro 300ms (l'utente che martella il pulsante)
    var now = Date.now();
    if (now - lastTapTimestamp < 300) return;
    lastTapTimestamp = now;

    var target = e.target;
    if (!target || !target.closest) return;

    var wrapper = target.closest('shopify-accelerated-checkout, .shopify-payment-button');
    if (!wrapper) return;

    // Se il bottone reale è già pronto, lascia fare al browser
    if (findHydratedButton(wrapper)) return;

    // Skeleton state: cattura il tap e programma il retry
    if (e.cancelable) {
      e.preventDefault();
    }

    scheduleRetry(wrapper);
  }

  // Cattura sia touchstart (tap mobile prima che diventi click) sia click (desktop + fallback)
  document.addEventListener('touchstart', handlePotentialSkeletonTap, true);
  document.addEventListener('click', handlePotentialSkeletonTap, true);
})();
